import en from "./en.js";
import jp from "./ja.js";

// jsonを結合する
var messages = Object.assign(en, jp);

export { messages };
